import addressFormSelector from './AddressFormSelector';
import { AddressFormView } from './AddressFormView';
import {
    changeAddress1,
    changeAddress2,
    changeCity,
    changeState,
    changeZip,
    AddressFormActionCreators,
} from './AddressFormActions';
import { connect } from 'react-redux';

export function mapStateToProps(state) {
    const addressForm = addressFormSelector(state);
    const isValid =
        addressForm.address1 !== '' &&
        addressForm.city !== '' &&
        addressForm.selectedState !== '' &&
        addressForm.zip !== '';

    return {
        isValid,
        ...addressForm,
    };
}

export const mapDispatchToProps = {
    changeAddress1,
    changeAddress2,
    changeCity,
    changeState,
    changeZip,
    ...AddressFormActionCreators,
};

export const AddressFormConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(AddressFormView);
